import React from 'react';
interface PriceDisplayProps {
  amountARS?: number;
  className?: string;
}
export function PriceDisplay({
  amountARS = 14999,
  className = ''
}: PriceDisplayProps) {
  const formatted = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0
  }).format(amountARS);
  return <span className={className} data-id="element-2">{formatted}</span>;
}